import {postMethod, putMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareBookCruise', request)
}

async function put(basketKey, request) {
    return await putMethod(`/api/prepareBookCruise/${basketKey}`, request)
}

export {post, put}
